import ApplicationAdapter from 'uplisting-frontend/adapters/application';

export default class CalendarAdapter extends ApplicationAdapter {
  fetchCalendar(query: object, signal: AbortSignal): Promise<object> {
    const url = this.buildURL('calendar', null, null, 'query', query);

    return this.ajax(url, 'GET', { data: query, signal }) as Promise<object>;
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    calendar: CalendarAdapter;
  }
}
